import React from "react";
import Icon from "@mui/material/Icon";

// Core layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Setup from "layouts/setup";
import SystemSetupPage from "layouts/system-setup";

// HR Module
import EmployeeManagement from "layouts/hr/EmployeeManagement";
import StaffList from "layouts/hr/EmployeeManagement/StaffList";
import EmployeeList from "layouts/hr/EmployeeManagement/EmployeeList";
import StaffProfile from "layouts/hr/EmployeeManagement/StaffProfile";
import AddEditStaff from "layouts/hr/EmployeeManagement/AddEditStaff";

// Variations
import TemporaryStoppage from "layouts/variations/temporarystoppage";
import ReviewApproval from "layouts/variations/review-approval";
import InitiateVariation from "layouts/variations/InitiateVariation";
import ReviewVariations from "layouts/variations/ReviewVariations";
import VariationReports from "layouts/variations/VariationReports";
import PendingVariations from "layouts/variations/review-approval/PendingVariations";
import VariationLoaders from "layouts/variations/VariationLoaders";
import Approvevariation from "layouts/variations/review-approval/approvevariation";
import VariationBatches from "layouts/variations/VariationBatches";
import VariationBatchDetail from "layouts/variations/VariationBatchDetail";

// Temporary stoppage
import CreateTemporaryStoppage from "layouts/variations/temporarystoppage/CreateTemporaryStoppage";
import ManageTemporaryStoppage from "layouts/variations/temporarystoppage/ManageTemporaryStorage";
import ResumeStaff from "layouts/variations/temporarystoppage/ResumeStaff";
import TemporaryStoppagesList from "layouts/variations/temporarystoppage/TemporaryStoppagesList";

// Payroll
import Payroll from "layouts/payroll";
import ExitDueReview from "layouts/payroll/ExitDueReview";
import Payslip from "layouts/payroll/Payslip";
import PayrollRun from "layouts/payroll/PayrollRun";
import PayrollPreview from "layouts/payroll/PayrollPreview";
import PayrollApproval from "layouts/payroll/PayrollApproval";
import PayrollHistory from "layouts/payroll/PayrollHistory";

// Pay Items
import RecurringAllowances from "layouts/payItems/RecurringAllowances";
import RecurringDeductions from "layouts/payItems/RecurringDeductions";
import Loans from "layouts/payItems/Loans";
import Arrears from "layouts/payItems/Arrears";

// Setup submodules
import PayItems from "layouts/setup/PayItems";
import Grades from "layouts/setup/Grade";
import Cadres from "layouts/setup/Cadres";
import StaffDetails from "layouts/setup/StaffDetails";
import StaffGroups from "layouts/setup/StaffGroup";
import Earnings from "layouts/setup/Earnings";
import Designations from "layouts/setup/Designations";
import MapSalaryStructures from "layouts/setup/MapSalaryStructures";
import DesignationDetails from "layouts/setup/DesignationDetails";
import CadreDetails from "layouts/setup/CadreDetails";
import SalaryStructures from "layouts/setup/SalaryStructures";
import Deductions from "layouts/setup/Deductions";
import StaffCategories from "layouts/setup/StaffCategories";
import NonRegularEarnings from "layouts/setup/NonRegularEarnings";
import ArrearsUpload from "layouts/setup/ArrearsUpload";
import IrregularAllowances from "layouts/setup/IrregularAllowances";

// Reports
import Payslips from "layouts/reports/Payslips";
import NominalRoll from "layouts/reports/NominalRoll";
import ManagementReports from "layouts/reports/ManagementReports";
import EmployeeReports from "layouts/reports/EmployeeReports";
import NetPaySchedule from "layouts/reports/NetPaySchedule";
import PayrollSummary from "layouts/reports/PayrollSummary";
import PayrollDetailed from "layouts/reports/PayrollDetailed";
import TaxReports from "layouts/reports/TaxReports";
import PensionReports from "layouts/reports/PensionReports";
import NHFReports from "layouts/reports/NHFReports";
import NHISReports from "layouts/reports/NHISReports";
import UnionReports from "layouts/reports/UnionReports";
import CoopReports from "layouts/reports/CoopReports";

// Settings
import OrgSetup from "layouts/settings/OrgSetup";
import SalarySetup from "layouts/settings/SalarySetup";
import UserManagement from "layouts/settings/UserManagement";
import SecurityLogs from "layouts/settings/SecurityLogs";
import PayrollConfig from "layouts/settings/PayrollConfig";
import TaxRegimes from "layouts/settings/TaxRegimes";
import TaxClaims from "layouts/settings/TaxClaims";
import TaxDeductionTypes from "layouts/settings/TaxDeductionTypes";
import TaxPolicies from "layouts/settings/TaxPolicies";
import TaxClaimsV2 from "layouts/settings/TaxClaimsV2";

// Support
import FAQs from "layouts/support/FAQs";
import ContactSupport from "layouts/support/ContactSupport";

// System
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

import PayrollExceptions from "layouts/payroll/PayrollExceptions";
import PayrollEnterpriseControls from "pages/payroll/PayrollEnterpriseControls";
import PayrollDisbursement from "layouts/payroll/PayrollDisbursement";
import PayrollCalendar from "layouts/payroll/PayrollCalendar";
import PayrollPerformance from "layouts/payroll/PayrollPerformance";
const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },

  {
    type: "title",
    title: "HR",
    key: "hr-title",
  },
  {
    type: "collapse",
    name: "Employee Management",
    key: "employee-management",
    route: "/employee-management",
    icon: <Icon>people</Icon>,
    component: <EmployeeManagement />,
  },
  {
    type: "route",
    name: "Staff List / Nominal Roll",
    key: "staff-list",
    route: "/hr/employee-management/stafflist",
    component: <StaffList />,
  },
  {
    type: "route",
    name: "Employee List",
    key: "employee-list",
    route: "/hr/employee-management/employeelist",
    component: <EmployeeList />,
  },
  {
    type: "route",
    name: "Staff Profile",
    key: "staff-profile",
    route: "/hr/employees/profile",
    component: <StaffProfile />,
  },
  {
    type: "route",
    name: "Add / Edit Staff",
    key: "add-edit-staff",
    route: "/hr/employee-management/add-edit",
    component: <AddEditStaff />,
  },

  {
    type: "title",
    title: "Variations",
    key: "variations-title",
  },
  {
    type: "route",
    name: "Initiate Variation",
    key: "initiate-variation",
    route: "/variations/initiate",
    component: <InitiateVariation />,
  },
  {
    type: "route",
    name: "Review & Approve",
    key: "review-variations",
    route: "/variations/review",
    component: <ReviewVariations />,
  },
  {
    type: "route",
    name: "Approve Variation",
    key: "approve-variations",
    route: "/variations/review/approve",
    component: <Approvevariation />,
  },
  {
    type: "route",
    name: "Pending Variation",
    key: "pending-variations",
    route: "/variations/review/pending",
    component: <PendingVariations />,
  },
  {
    type: "collapse",
    name: "Temporary Stoppage",
    key: "temporary-stoppage",
    route: "/variations/temporarystoppage",
    icon: <Icon>event_busy</Icon>,
    component: <TemporaryStoppage />,
  },
  {
    type: "route",
    name: "Create Temporary Stoppage",
    key: "create-temp-stoppage",
    route: "/variations/temporarystoppage/create",
    component: <CreateTemporaryStoppage />,
  },
  {
    type: "route",
    name: "Manage Temporary Stoppage",
    key: "manage-temp-stoppage",
    route: "/variations/temporarystoppage/manage",
    component: <ManageTemporaryStoppage />,
  },
  {
    type: "route",
    name: "Resume Staff",
    key: "resume-temp-stoppage",
    route: "/variations/temporarystoppage/resume",
    component: <ResumeStaff />,
  },
  {
    type: "route",
    name: "List Temporary Stoppage",
    key: "list-temp-stoppage",
    route: "/variations/temporarystoppage/list",
    component: <TemporaryStoppagesList />,
  },
  {
    type: "collapse",
    name: "Variation Loaders",
    key: "variation-loaders",
    route: "/variations/loaders",
    icon: <Icon fontSize="small">cloud_upload</Icon>,
    component: <VariationLoaders />,
  },
  {
    type: "collapse",
    name: "Variation Review & Approval",
    key: "review-approval",
    route: "/variations/review-approval",
    icon: <Icon fontSize="small">fact_check</Icon>,
    component: <ReviewApproval />,
  },
  {
    type: "collapse",
    name: "Variation Batches",
    key: "variation-batches",
    route: "/variations/batches",
    icon: <Icon fontSize="small">upload_file</Icon>,
    component: <VariationBatches />,
  },
  {
    type: "route",
    name: "Variation Batch Detail",
    key: "variation-batch-detail",
    route: "/variations/batches/:id",
    component: <VariationBatchDetail />,
  },
  {
    type: "collapse",
    name: "Variation Reports",
    key: "variation-reports",
    route: "/variations/reports",
    icon: <Icon fontSize="small">assessment</Icon>,
    component: <VariationReports />,
  },

  {
    type: "title",
    title: "Payroll",
    key: "payroll-title",
  },
  {
    type: "collapse",
    name: "Payroll Operations",
    key: "payroll-operations",
    route: "/payroll",
    icon: <Icon>attach_money</Icon>,
    component: <Payroll />,
  },
  {
    type: "route",
    name: "Payroll Calendar",
    key: "payroll-calendar",
    route: "/payroll/calendar",
    component: <PayrollCalendar />,
  },
  {
    type: "route",
    name: "Payroll Run",
    key: "payroll-run",
    route: "/payroll/run",
    component: <PayrollRun />,
  },
  {
    type: "route",
    name: "Payroll Preview",
    key: "payroll-preview",
    route: "/payroll/preview",
    component: <PayrollPreview />,
  },
  {
    type: "route",
    name: "Payroll Approval",
    key: "payroll-approval",
    route: "/payroll/approval",
    component: <PayrollApproval />,
  },
  {
    type: "route",
    name: "Payroll History",
    key: "payroll-history",
    route: "/payroll/history",
    component: <PayrollHistory />,
  },
  {
    type: "route",
    name: "Payroll Exceptions",
    key: "payroll-exceptions",
    route: "/payroll/exceptions",
    component: <PayrollExceptions />,
  },
  {
    type: "collapse",
    name: "Enterprise Controls",
    key: "payroll-enterprise-controls",
    route: "/payroll/enterprise-controls",
    component: <PayrollEnterpriseControls />,
  },
  {
    type: "route",
    name: "Payroll Disbursement",
    key: "payroll-disbursement",
    route: "/payroll/disbursement",
    component: <PayrollDisbursement />,
  },
  {
    type: "route",
    name: "Performance & Queues",
    key: "payroll-performance",
    route: "/payroll/performance",
    component: <PayrollPerformance />,
  },
  {
    type: "route",
    name: "Exit Due Review",
    key: "exit-due-review",
    route: "/payroll/exit-due-review",
    component: <ExitDueReview />,
  },
  {
    type: "route",
    name: "Payslip",
    key: "payslip",
    route: "/payroll/payslip",
    component: <Payslip />,
  },

  {
    type: "title",
    title: "Pay Items",
    key: "pay-items-title",
  },
  {
    type: "collapse",
    name: "Recurring Allowances",
    key: "recurring-allowances",
    icon: <Icon>payments</Icon>,
    route: "/pay-items/allowances",
    component: <RecurringAllowances />,
  },
  {
    type: "collapse",
    name: "Recurring Deductions",
    key: "recurring-deductions",
    icon: <Icon>money_off</Icon>,
    route: "/pay-items/deductions",
    component: <RecurringDeductions />,
  },
  {
    type: "collapse",
    name: "Loans",
    key: "loans",
    icon: <Icon>account_balance</Icon>,
    route: "/pay-items/loans",
    component: <Loans />,
  },
  {
    type: "collapse",
    name: "Arrears",
    key: "arrears",
    icon: <Icon>receipt_long</Icon>,
    route: "/pay-items/arrears",
    component: <Arrears />,
  },

  {
    type: "title",
    title: "Reports",
    key: "reports-title",
  },
  {
    type: "collapse",
    name: "Reports",
    key: "reports",
    icon: <Icon>description</Icon>,
    collapse: [
      {
        type: "route",
        name: "Payslips",
        key: "payslips",
        route: "/reports/payslips",
        component: <Payslips />,
      },
      {
        type: "route",
        name: "Nominal Roll",
        key: "nominal-roll",
        route: "/reports/nominal-roll",
        component: <NominalRoll />,
      },
      {
        type: "route",
        name: "Management Reports",
        key: "management-reports",
        route: "/reports/management",
        component: <ManagementReports />,
      },
      {
        type: "route",
        name: "Employee Reports",
        key: "employee-reports",
        route: "/reports/employee",
        component: <EmployeeReports />,
      },
      {
        type: "route",
        name: "Variation Reports",
        key: "variation-reports-report-group",
        route: "/variations/reports",
        component: <VariationReports />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Payment Reports",
    key: "payment-reports",
    icon: <Icon>payments</Icon>,
    collapse: [
      {
        type: "route",
        name: "Net Pay Schedule",
        key: "netpay-schedule",
        route: "/reports/payment/netpay",
        component: <NetPaySchedule />,
      },
      {
        type: "route",
        name: "Grand Summary",
        key: "grand-summary",
        route: "/reports/payment/summary",
        component: <PayrollSummary />,
      },
      {
        type: "route",
        name: "Detailed Reports",
        key: "payroll-detailed",
        route: "/reports/payment/detailed",
        component: <PayrollDetailed />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Statutory & Compliance",
    key: "statutory-reports",
    icon: <Icon>rule</Icon>,
    collapse: [
      {
        type: "route",
        name: "Tax Reports",
        key: "tax-reports",
        route: "/reports/statutory/tax",
        component: <TaxReports />,
      },
      {
        type: "route",
        name: "Pension Reports",
        key: "pension-reports",
        route: "/reports/statutory/pension",
        component: <PensionReports />,
      },
      {
        type: "route",
        name: "NHF Reports",
        key: "nhf-reports",
        route: "/reports/statutory/nhf",
        component: <NHFReports />,
      },
      {
        type: "route",
        name: "NHIS/HMO Reports",
        key: "nhis-reports",
        route: "/reports/statutory/nhis",
        component: <NHISReports />,
      },
      {
        type: "route",
        name: "Union Reports",
        key: "union-reports",
        route: "/reports/statutory/union",
        component: <UnionReports />,
      },
      {
        type: "route",
        name: "Co-op & Others",
        key: "coop-reports",
        route: "/reports/statutory/coop",
        component: <CoopReports />,
      },
    ],
  },

  {
    type: "title",
    title: "Settings",
    key: "settings-title",
  },
  {
    type: "collapse",
    name: "Admin Settings",
    key: "settings",
    icon: <Icon>settings</Icon>,
    collapse: [
      {
        type: "route",
        name: "Organization Setup",
        key: "org-setup",
        route: "/settings/organization",
        component: <OrgSetup />,
      },
      {
        type: "route",
        name: "Salary Structures & Pay Items",
        key: "salary-setup",
        route: "/settings/salary",
        component: <SalarySetup />,
      },
      {
        type: "route",
        name: "User & Role Management",
        key: "user-management",
        route: "/settings/users",
        component: <UserManagement />,
      },
      {
        type: "route",
        name: "Security & Audit Logs",
        key: "security-logs",
        route: "/settings/security",
        component: <SecurityLogs />,
      },
      {
        type: "route",
        name: "Payroll Configurations",
        key: "payroll-config",
        route: "/settings/payroll-config",
        component: <PayrollConfig />,
      },
      {
        type: "route",
        name: "Tax Regimes",
        key: "tax-regimes",
        route: "/settings/tax-regimes",
        component: <TaxRegimes />,
      },
      {
        type: "route",
        name: "Tax Claims",
        key: "tax-claims",
        route: "/settings/tax-claims",
        component: <TaxClaims />,
      },
      {
        type: "route",
        name: "Tax Deduction Types",
        key: "tax-deduction-types",
        route: "/settings/tax-deduction-types",
        component: <TaxDeductionTypes />,
      },
      {
        type: "route",
        name: "Tax Policies",
        key: "tax-policies",
        route: "/settings/tax-policies",
        component: <TaxPolicies />,
      },
      {
        type: "route",
        name: "Tax Claims V2",
        key: "tax-claims-v2",
        route: "/settings/tax-claims-v2",
        component: <TaxClaimsV2 />,
      },
    ],
  },

  {
    type: "collapse",
    name: "Organization Setup",
    key: "setup",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/setup",
    component: <Setup />,
    collapse: [
      {
        type: "route",
        name: "System Setup",
        key: "system-setup",
        route: "/system-setup",
        component: <SystemSetupPage />,
      },
      {
        type: "route",
        name: "Pay Items",
        key: "pay-items",
        route: "/setup/pay-items",
        component: <PayItems />,
      },
      {
        type: "route",
        name: "Grade Level",
        key: "grade-levels",
        route: "/setup/grade-levels",
        component: <Grades />,
      },
      {
        type: "route",
        name: "Cadres",
        key: "cadres",
        route: "/setup/cadres",
        component: <Cadres />,
      },
      {
        type: "route",
        name: "Staff Payment Details",
        key: "staff-details",
        route: "/setup/staffdetails",
        component: <StaffDetails />,
      },
      {
        type: "route",
        name: "Non Regular Earnings",
        key: "nonregularearnings",
        route: "/setup/nonregularearnings",
        component: <NonRegularEarnings />,
      },
      {
        type: "route",
        name: "Arrears Upload",
        key: "arrearsupload",
        route: "/setup/arrearsupload",
        component: <ArrearsUpload />,
      },
      {
        type: "route",
        name: "Irregular Allowances",
        key: "irregular-allowances",
        route: "/setup/irregularallowances",
        component: <IrregularAllowances />,
      },
      {
        type: "route",
        name: "Staff Categories",
        key: "staff-categories",
        route: "/setup/staff-categories",
        component: <StaffCategories />,
      },
      {
        type: "route",
        name: "Designations",
        key: "designations",
        route: "/setup/designations",
        component: <Designations />,
      },
      {
        type: "route",
        name: "Salary Structures",
        key: "salary-structures",
        route: "/setup/salary-structures",
        component: <SalaryStructures />,
      },
      {
        type: "route",
        name: "Staff Groups",
        key: "staff-groups",
        route: "/setup/staff-group",
        component: <StaffGroups />,
      },
      {
        type: "route",
        name: "Mapped Salary Structure",
        key: "map-salary-structures",
        route: "/setup/map-salary-structure",
        component: <MapSalaryStructures />,
      },
      {
        type: "route",
        name: "View Designation Details",
        key: "designation-details",
        route: "/setup/designation/details",
        component: <DesignationDetails />,
      },
      {
        type: "route",
        name: "View Cadre Details",
        key: "cadre-details",
        route: "/setup/cadre/details",
        component: <CadreDetails />,
      },
      {
        type: "route",
        name: "Earnings",
        key: "earnings",
        route: "/setup/earnings",
        component: <Earnings />,
      },
      {
        type: "route",
        name: "Deductions",
        key: "deductions",
        route: "/setup/deductions",
        component: <Deductions />,
      },
    ],
  },

  {
    type: "title",
    title: "Support / Help",
    key: "support-title",
  },
  {
    type: "collapse",
    name: "Help & Support",
    key: "support",
    icon: <Icon>help_outline</Icon>,
    collapse: [
      {
        type: "route",
        name: "FAQs & User Guide",
        key: "faqs",
        route: "/support/faqs",
        component: <FAQs />,
      },
      {
        type: "route",
        name: "Contact Support",
        key: "contact-support",
        route: "/support/contact",
        component: <ContactSupport />,
      },
    ],
  },

  {
    type: "route",
    name: "Tables",
    key: "tables",
    route: "/tables",
    component: <Tables />,
  },
  {
    type: "route",
    name: "RTL",
    key: "rtl",
    route: "/rtl",
    component: <RTL />,
  },
  {
    type: "route",
    name: "Notifications",
    key: "notifications",
    route: "/notifications",
    component: <Notifications />,
  },
  {
    type: "route",
    name: "Profile",
    key: "profile",
    route: "/profile",
    component: <Profile />,
  },
  {
    type: "route",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "route",
    name: "Sign Up",
    key: "sign-up",
    route: "/authentication/sign-up",
    component: <SignUp />,
  },

  {
    type: "route",
    key: "legacy-initiate-variation",
    route: "/variation/initiate",
    component: <InitiateVariation />,
  },
  {
    type: "route",
    key: "legacy-review-variation",
    route: "/variation/review",
    component: <ReviewVariations />,
  },
  {
    type: "route",
    key: "legacy-approve-variation",
    route: "/variation/review/approve",
    component: <Approvevariation />,
  },
  {
    type: "route",
    key: "legacy-pending-variation",
    route: "/variation/review/pending",
    component: <PendingVariations />,
  },
  {
    type: "route",
    key: "legacy-variation-loaders",
    route: "/variation/variationloaders",
    component: <VariationLoaders />,
  },
  {
    type: "route",
    key: "legacy-variation-reports",
    route: "/variation/reports",
    component: <VariationReports />,
  },
];

export default routes;
